const GAMES_PATH = "/games";
const TOOLS_PATH = "/tools";

export const RoutePath = {
  ROOT: "/",
  LOGIN: "/login",
  SOCIALS: "/socials",
  GAMES: GAMES_PATH,
  MATTHIJSLE: GAMES_PATH + "/matthijsle",
  SNAKE: GAMES_PATH + "/snake",
  MINESWEEPER: GAMES_PATH + "/minesweeper",
  MUSIC_QUIZ: GAMES_PATH + "/music_quiz",
  TETRIS: GAMES_PATH + "/tetris",
  TFE: GAMES_PATH + "/2048",
  TEST: "/test",
  TOOLS: TOOLS_PATH,
  GUITAR_TUNER: TOOLS_PATH + "/guitar_tuner",
  CALCULATOR: TOOLS_PATH + "/calculator",
  PIANO: TOOLS_PATH + "/piano",
  CHESS: "/chess",
  THIRTY_SECONDS: GAMES_PATH + "/30seconds",
  SOLITAIRE: GAMES_PATH + "/solitaire",
  HITSTER: GAMES_PATH + "/hitster"
};
